import { DATE_FILTERS } from 'public/components/kye-canvas-table/canvas-table'

/**
 * 2022-12-08
 * 与表格相关
 */
const HISTORY_WIDTH = 'GLOBAL_COL_HISTORY_WIDTH'
const WIDTH = 'GLOBAL_COL_WIDTH'
function getHistoryDataByTableKey (tableKey) {
  let res = localStorage.getItem(HISTORY_WIDTH)
  try {
    res = JSON.parse(res)
    res = res[tableKey]
  } catch (e) {
    res = {}
  }
  return res || {}
}

function setHistoryData (tableKey, data = {}) {
  let res = localStorage.getItem(HISTORY_WIDTH)
  try {
    res = JSON.parse(res) || {}
  } catch (e) {
    res = {}
  }
  res[tableKey] = data
  res = deleteCacheItem(res)
  localStorage.setItem(HISTORY_WIDTH, JSON.stringify(res))
}

function getUserDataByTableKey (tableKey) {
  let res = localStorage.getItem(WIDTH)
  try {
    res = JSON.parse(res)
    res = res[tableKey]
  } catch (e) {
    res = {}
  }
  return res || {}
}

function setUserData (tableKey, data = {}) {
  let res = localStorage.getItem(WIDTH)
  try {
    res = JSON.parse(res) || {}
  } catch (e) {
    res = {}
  }
  res[tableKey] = data
  res = deleteCacheItem(res)
  localStorage.setItem(WIDTH, JSON.stringify(res))
}

function deleteCacheItem (res) {
  const arr = Object.keys(res)
  arr.forEach(tableKey => {
    const fields = Object.keys(res[tableKey])
    if (fields.length === 0) {
      delete res[tableKey]
    }
  })
  return res
}

function isNumber (width) {
  return /^[0-9]+$/.test(width)
}

// 对比差异
function updateColumnWidth (col, data, historyData) {
  const cols = Object.keys(data)
  const key = col.key
  const width = parseInt(col.width)

  if (cols.includes(key)) {
    // 1、首次是 auto，变更为实际宽度（数字）
    // 2、首次是 实际宽度（数字），变更为 auto
    // 3、一直是 aut0
    // 4、一直都是 数字
    const historyWidth = parseInt(historyData[key])
    if (historyData.hasOwnProperty(key) && ((isNumber(width) && isNumber(historyWidth) && historyWidth !== width) || (isNumber(width) && !isNumber(historyWidth)) || (!isNumber(width) && isNumber(historyWidth)))) {
      delete data[key]
      delete historyData[key]
    } else {
      historyData[key] = width
    }
  }
}

function findColumn (columns, key) {
  let item = {}
  columns.forEach(col => {
    if (col.children && col.children.length) {
      col.children.forEach(child => {
        if (child.key === key) {
          item = {
            ...child,
            isTwoHeader: true
          }
        }
      })
    } else {
      if (col.key === key) {
        item = col
      }
    }
  })
  return item
}

/**
 * 表格列宽优先级处理：
 * 有缓存拖拽数据的情况：
 * 1、对比当前已经拖拽字段，是否变更配置（新旧数据对比）
 * 2、如果变更，则优先取配置数据，清掉拖拽宽度数据
 * 3、如果没有变更， 则缓存历史配置数据备份 GLOBAL_COL_HISTORY_WIDTH
 * 无缓存拖拽数据的情况：
 * 1、拖拽时检查是否缓存过旧数据
 * 2、如果旧数据，则换成旧数据
 */
export function initColWidth (tableKey, originArr) {
  let data = getUserDataByTableKey(tableKey)
  let historyData = getHistoryDataByTableKey(tableKey)
  if (data) {
    originArr.forEach(col => {
      if (col.children && col.children.length) {
        col.children.forEach(child => {
          // 对比差异，考虑是否备份历史数据
          updateColumnWidth(child, data, historyData)
        })
      } else {
        // 对比是否备份历史数据
        updateColumnWidth(col, data, historyData)
      }
    })
    setUserData(tableKey, data)
    setHistoryData(tableKey, historyData)
  }
}

export function setHistoryDataByDragColumn (tableKey, key, columns) {
  const col = findColumn(columns, key)
  let data = getHistoryDataByTableKey(tableKey)
  if (data && !data.hasOwnProperty(key)) {
    // col._width是auto的源数据，如果源数据的是auto,则使用auto. 因为auto会重新计算真实的宽度值
    let width = col._width || parseInt(col.width)
    // 2023-01-08 自定义列配置，时间类型字段处理
    if (DATE_FILTERS.includes(col.filter) && !col.isTwoHeader) {
      width -= 8
    }
    data[key] = width
  }
  setHistoryData(tableKey, data)
}




// WEBPACK FOOTER //
// ./src/public/components/query-table/module/table-column.js